import { gql } from '@apollo/client';

export const FETCH_TRUST_BALANCE = gql`
  query FetchTrustBalance($input: GetTrustBalanceInput!) {
    statistic: getTrustBalance(getTrustBalanceInput: $input) {
      balance
    }
  }
`;
